import { merge } from 'lodash';
import type { EChartsOption, ECharts } from 'echarts';

export const flushBrush = (instance: ECharts | undefined, options: EChartsOption) => {
  const { brushType = '', brushMode = '' } = (options.brush || {}) as any;

  if (!instance || instance.isDisposed()) return;

  try {
    if (brushType) {
      instance.dispatchAction({
        type: 'takeGlobalCursor',
        key: 'brush',
        brushOption: { brushType, brushMode },
      });
    } else {
      instance.dispatchAction({
        type: 'takeGlobalCursor',
        key: 'brush',
        brushOption: { brushType: false },
      });
    }
  } catch {
    // do nothing
  }
};

export const customizerMerge = (value: any, srcValue: any) => {
  if (!Array.isArray(value) && value !== undefined && Array.isArray(srcValue)) {
    return srcValue.map((it) => merge({}, value, it));
  }

  return undefined;
};
